import React from "react"

import { FormikValues, useFormikContext } from "formik"

import { CheckboxInput } from "~tailwindui/Form"

import { ErrorMessage } from "components/Forms/Formik"

import IssueCheckbox from "./IssueCheckbox"

const TechIssues = () => {
  const { values }: FormikValues = useFormikContext()

  return (
    <div className="my-2">
      <CheckboxInput
        label="Did you or the student(s) experience any technical issues today?"
        name="hadTechIssues"
        checkboxType="radio"
        options={[
          { label: "No", value: false },
          { label: "Yes", value: true },
        ]}
      />

      {values.hadTechIssues && (
        <>
          <p className="mb-2">Please select all that apply:</p>
          <ErrorMessage name="sessionTechIssues" />
          <IssueCheckbox
            name="whiteboard"
            label="Whiteboard"
            hint="Miro slow, unable to log into Miro, etc"
          />
          <IssueCheckbox
            name="internet"
            label="Internet"
            hint="Poor video quality, lagging, etc"
          />
          <IssueCheckbox
            name="device"
            label="Devices"
            hint="Issues with student camera/microphones, etc"
          />
          <IssueCheckbox
            name="cloudroom"
            label="Cloudroom"
            hint="Controls not working, error message, etc"
            descriptionRequired
          />
          <IssueCheckbox name="other" label="Other" descriptionRequired />
        </>
      )}
    </div>
  )
}

export default TechIssues
